import React from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../redux/reducers/authSlice";
import HelmetWrapper from "../HelmetWrapper";

const UnAuthorized = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    navigate("/login", { state: { from: pathname } });
    dispatch(logout());
    // try {
    //   dispatch(logout());
    //   navigate("/login", { replace: true });
    // } catch (error) {
    //   console.log(error);
    // }
  };

  // const handleReturn = () => {
  //   if (document.referrer) {
  //     navigate(-1);
  //   } else {
  //     handleLogout();
  //   }
  // };

  return (
    <HelmetWrapper title="WTF: UnAuthorized">
      <div>
        <div className="flex-k js-center-k items-center-k flex-col-k h-75vh-k">
          <h1 className="fs-900-k bolder-text">403</h1>
          <p className="fs-med-k">You are not authorised to view this page!</p>
          <Link
            // onClick={handleReturn}
            onClick={() => navigate(-1)}
            className="decoration-none-k fs-normal-k">
            {"< Return Back"}
          </Link>
          <button
            type="button"
            className="btn btn-danger mt30"
            onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </HelmetWrapper>
  );
};

export default UnAuthorized;
